import { apiClient } from '../../app/api/client';

import type {
  OptimizationRunAccepted,
  OptimizationRunRecord,
  OptimizationSubmission,
} from './types';

export interface OptimizationApi {
  cancel(runId: string): Promise<OptimizationRunRecord>;
  canonicalHash(submission: OptimizationSubmission): Promise<string>;
  create(submission: OptimizationSubmission): Promise<OptimizationRunAccepted>;
  get(runId: string): Promise<OptimizationRunRecord>;
  list(): Promise<OptimizationRunRecord[]>;
  resume(runId: string, additionalTimeBudgetS: number): Promise<OptimizationRunAccepted>;
}

export const optimizationApi: OptimizationApi = {
  cancel: (runId) => apiClient.post(`/optimization/runs/${runId}/cancel`),
  canonicalHash: async (submission) => {
    const response = await apiClient.post<{ input_hash: string }>(
      '/optimization/submission-hash',
      { json: submission },
    );
    return response.input_hash;
  },
  create: (submission) =>
    apiClient.post('/optimization/runs', { json: submission }),
  get: (runId) => apiClient.get(`/optimization/runs/${runId}`),
  list: () => apiClient.get('/optimization/runs'),
  resume: (runId, additionalTimeBudgetS) =>
    apiClient.post(`/optimization/runs/${runId}/resume`, {
      json: { additional_time_budget_s: additionalTimeBudgetS },
    }),
};
